import React, { ReactNode, MouseEvent, FC } from 'react';
import styled from '@emotion/styled';
import { Tooltip } from '../../popovers';

const Link = styled.a<{ disabled: number }>`
  color: #4694ce;
  text-decoration: none;
  height: 100%;
  width: 100%;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: #fff;
    text-decoration: none;
  }
`;

const Label = styled.li`
  border-left: 1px solid #e4e4e4;
  list-style: none;
  line-height: 1em;
  cursor: pointer;
  & > div {
    padding: 0 0.8rem 0 0.4rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const ItemContent = styled.div<{ isDisabled: number }>`
  display: flex;
  justify-content: center;
  align-items: center;

  color: ${p => (p.isDisabled ? '#878787' : '#4694ce')};

  :hover {
    background-color: ${p => (p.isDisabled ? 'unset' : '#4694ce')};
    border-bottom: ${p => (p.isDisabled ? 'unset' : '1px solid #e4e4e4;')};
    color: ${p => (p.isDisabled ? '#878787' : '#ffffff')};
  }
  > span {
    margin-left: 0.5rem;
  }

  > a > span {
    margin-left: 0.5rem;
  }

  :hover span {
    color: ${p => (p.isDisabled ? '#878787' : '#ffffff')};
  }
`;

const ResponsiveIconWrapper = styled.span`
  display: none;

  @media (min-width: 66.5rem) {
    display: inline-block;
  }
`;

type ToolbarItemProps =
  | {
      icon: ReactNode;
      link?: string;
      text: string;
      disabled?: boolean;
      disabledText?: string;
    }
  | {
      icon: ReactNode;
      clickFn?: React.EventHandler<MouseEvent>;
      text: string;
      disabled?: boolean;
      disabledText?: string;
    };

export const ToolbarItem: FC<ToolbarItemProps> = props => {
  const onClick: React.EventHandler<MouseEvent> = ev => {
    if (props.disabled) {
      return;
    }
    if ('link' in props) {
      return window.open(props.link, '_blank');
    }
    if ('clickFn' in props && props.clickFn) {
      return props.clickFn(ev);
    }
  };
  return (
    <Label onClick={onClick}>
      <Tooltip text={props.disabled ? props.disabledText : undefined}>
        <ItemContent isDisabled={props.disabled ? 1 : 0}>
          <ResponsiveIconWrapper>{props.icon}</ResponsiveIconWrapper>
          <span>{props.text}</span>
        </ItemContent>
      </Tooltip>
    </Label>
  );
};

export default ToolbarItem;
